<template>
  <div>
    <b-modal id="modalEditCurrency" ref="modalEditCurrency" :title="$t('Currency')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label='ID' label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.currency_id" :disabled="isEdit" aria-describedby="inputFeedbackID" :state="editItem.currency_id > 0"/>
          <b-form-invalid-feedback id="inputFeedbackID">
              {{ $t('Enter number') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Abbreviation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.currency_brief_name" aria-describedby="inputFeedbackAbbreviation" :state="editItem.currency_brief_name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackAbbreviation">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.currency_full_name" aria-describedby="inputFeedbackName" :state="editItem.currency_full_name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Percent')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model.number="editItem.percent" :disabled="editItem.currency_id === 810" placeholder="0.0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Rate')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-input-group>
            <b-form-input type="number" v-model="editItem.rate" placeholder="0.0"/>
            <b-input-group-append>
              <md-button class="md-raised" @click="onlineUpdate" style="margin-top:0px">{{ $t('Online update') }}</md-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" v-if="isEdit" :label="$t('Currency rate history')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        </b-form-group>
        <b-table striped hover small v-if="isEdit"
          :items="editItem.ratesEditModal"
          :fields="fieldsRate"/>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditCurrency')"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: null,
    editItem: null
  },
  data () {
    return {
      fieldsRate: [
        {key: 'time', label: this.$i18n.t('Date'), sortable: true},
        {key: 'rate', label: this.$i18n.t('Rate'), sortable: true}
      ]
    }
  },
  methods: {
    async onlineUpdate () {
      if (!this.editItem.currency_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field ID'), 'Error')
        return
      }
      await this.$store.dispatch('ReferenceBooks/GET_ONLINE_UPDATE', this.editItem.currency_id).then(response => {
        this.editItem.rate = JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/ONLINE_UPDATE'])).rate
      })
    },
    save () {
      if (!this.editItem.currency_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field ID'), 'Error')
        return
      }
      if (!this.editItem.currency_full_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field abbreviation'), 'Error')
        return
      }
      if (!this.editItem.currency_brief_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field full name'), 'Error')
        return
      }
      if (!this.editItem.rate) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field rate'), 'Error')
        return
      }

      let copy = {}
      copy.full_name = this.editItem.currency_full_name
      copy.brief_name = this.editItem.currency_brief_name
      copy.id = Number(this.editItem.currency_id)
      copy.rate = Number(this.editItem.rate)
      copy.percent = Number(this.editItem.percent)
      let response = this.isEdit
        ? this.$store.dispatch('ReferenceBooks/UPDATE_CURRENCIES', copy)
        : this.$store.dispatch('ReferenceBooks/CREATE_CURRENCIES', copy)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'ReferenceBooks/GET_CURRENCIES')
          this.$refs.modalEditCurrency.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/currency/editModal.vue